import { PlusOutlined } from '@ant-design/icons';
import { gradeTags } from '@rockalingua/shared/tags/constants';

import Colors from './Colors';

const tagConfigById = {
  1: {
    name: 'Principiante',
    englishName: 'Beginner',
    color: Colors.green,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/78_thumb.jpg`,
  },
  2: {
    name: 'Emergente',
    englishName: 'Emerging',
    color: Colors.lightBlue,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/58_thumb.jpg`,
  },
  3: {
    name: 'Intermedio',
    englishName: 'Intermediate',
    color: Colors.orange,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/66_thumb.jpg`,
  },
  4: {
    name: 'Avanzado',
    englishName: 'Advanced',
    color: Colors.red,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/161/cover.webp`,
    labels: [
      <span key="grade">
        6 <PlusOutlined />
      </span>,
    ],
  },
};

export const tags = gradeTags.map((gradeTag) => {
  const config = tagConfigById[gradeTag.id];

  return {
    id: gradeTag.id,
    name: config.name,
    englishName: config.englishName,
    language: 'es',
    color: config.color,
    img: config.img,
    suggestedGrades: gradeTag.grades,
    labels: config.labels || gradeTag.grades,
  };
});

export const tagsWithAll = [
  {
    id: 'all',
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/161/cover.webp`,
    suggestedGrades: ['All'],
    labels: ['All'],
  },
  ...tags,
];
